<script setup>
    import Image from '@/components/Image.vue';

    defineProps(['step']);
    const emit = defineEmits(['select-option']);    
</script>

<template>
    <BButtonGroup class="btn-group config-tabs">
        <BButton
            v-for="(option, index) in step.options"
            :key="index"
            class="btn btn-md btn-secondary radio-tab radio-tab--2-line"
            :class="{ 'active': step.selected.value.id === option.id }"
            @click="emit('select-option', step, option)"
            :disabled="option.disabled && option.disabled.value"
        >
            <Image :src="option.image" />
            <div class="label-wrapper">
                <span>{{ option.label }}</span>
                <span class="label-secondary" v-if="option.labelSecondary">{{ option.labelSecondary }}</span>
            </div>
        </BButton>
    </BButtonGroup>
</template>